<template>
  <div class="container">
    <h2>{{ $t('titre.LivestockRecord') }} {{ detailMovement.serialNumber ? detailMovement.serialNumber : '-' }}</h2>
    <!--b-card :title="$t('livestock_records_management')" :class="isRtleft ? 'text-end' : 'text-start'"-->

    <div v-if="!detailMovement" class="card p-3 mb-4">
      <div> <!-- class="card-header bg-primary text-white" -->
        <!--h5 class="mb-0">{{ $t('livestock_details') }}</h5-->
      </div>

    </div>

    <!-- Form to show readOnly value -->
    <form class="row g-3 align-items-center justify-content-between mb-4">
      <div class="form-group row">
        <!-- Serial Number -->
        <label class="col-sm-2 text-start col-form-label">{{ $t('serial_number') }}</label>
        <div class="col-sm-2">
          <input type="text" class="form-control-plaintext" :value="detailMovement.serialNumber || '-'" readonly />
        </div>

        <!-- Date -->
        <label class="col-sm-1 text-start col-form-label">{{ $t('date') }}</label>
        <div class="col-sm-1">
          <input type="text" class="form-control-plaintext" :value="detailMovement.movementDate || '-'" readonly />
        </div>

        <!-- Value of Period -->
        <label class="col-sm-1 text-start col-form-label">{{ $t('valueOfPeriod') }}</label>
        <div class="col-sm-1">
          <input type="text" class="form-control-plaintext"
            :value="formatPeriod(detailMovement.valueOfPeriod, detailMovement.typeOfPeriod) || '-'" readonly />
        </div>

        <!-- Source -->
        <label class="col-sm-1 text-start col-form-label">{{ $t('source') }}</label>
        <div class="col-sm-3">
          <input type="text" class="form-control-plaintext" :value="detailMovement.source || '-'" readonly />
        </div>
      </div>
      <div class="form-group row">
        <!-- Remarque -->
        <label class="col-sm-2 text-start col-form-label">{{ $t('remarque') }}</label>
        <div class="col-sm-10">
          <input type="text" class="form-control-plaintext" :value="detailMovement.remarque || '-'" readonly />
        </div>
      </div>
    </form>


    <!-- Form Section -->
    <form @submit.prevent="saveRecord" class="row g-3 align-items-center justify-content-between">


      <div class="form-group row">
        <label for="recordDate" class="col-sm-2 text-start col-form-label">{{ $t('date') }}</label>
        <div class="col-sm-2">
          <input id="recordDate" v-model="formData.recordDate" type="date" class="form-control" required />
        </div>

        <label for="healthStatus" class="col-sm-2 text-start col-form-label">{{ $t('health_status') }}</label>
        <div class="col-sm-2">
          <input id="healthStatus" v-model="formData.healthStatus" class="form-control" required />
        </div>

        <label for="treatment" class="col-sm-1 text-start col-form-label">{{ $t('treatment') }}</label>
        <div class="col-sm-3">
          <input id="treatment" v-model="formData.treatment" class="form-control" />
        </div>
      </div>

      <div class="form-group row">
        <label for="vaccination" class="col-sm-2 text-start col-form-label">{{ $t('vaccination') }}</label>
        <div class="col-sm-4">
          <input id="vaccination" v-model="formData.vaccination" class="form-control" />
        </div>

        <label for="feedingNotes" class="col-sm-2 text-start col-form-label">{{ $t('feeding_notes') }}</label>
        <div class="col-sm-4">
          <input id="feedingNotes" v-model="formData.feedingNotes" class="form-control" />
        </div>
      </div>


      <div class="form-group row">
        <label for="otherObservations" class="col-sm-2 text-start col-form-label">{{ $t('observations') }}</label>
        <div class="col-sm-10">
          <input id="otherObservations" v-model="formData.otherObservations" class="form-control" />
        </div>
      </div>

      <div class="btn-update-cancel">
        <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80">
          <i class="fas fa-save"></i> {{ formData.id ? $t('update') : $t('add') }}
        </button>
        <button class="btn btn-outline-danger btn-sm btn-lg w-80" type="reset" @click="resetForm">
          <i class="bi bi-x"></i> {{ $t('cancel') }}
        </button>
      </div>
    </form>

    <!-- Table Section -->
    <div class="card mt-3">
      <table class="custom-table">
        <thead>
          <tr>
            <th>{{ $t('date') }}</th>
            <th>{{ $t('health_status') }}</th>
            <th>{{ $t('treatment') }}</th>
            <th>{{ $t('vaccination') }}</th>
            <th>{{ $t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in records" :key="index">
            <td>{{ record.recordDate }}</td>
            <td>{{ record.healthStatus }}</td>
            <td>{{ record.treatment }}</td>
            <td>{{ record.vaccination }}</td>
            <td>
              <div class="btn-edit-delete">
                <button class="btn btn-outline-primary btn-sm me-2" @click="editRecord(record)">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn btn-outline-danger btn-sm" @click="deleteRecord(record.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LivestockRecordService } from '../api';
import { Message } from "../libjs/alertService";

export default {
  data() {
    return {
      detailMovement: {}, // history.state.detailMovement || {},
      records: [],
      formData: {
        id: null,
        recordDate: "",
        healthStatus: "",
        treatment: "",
        vaccination: "",
        feedingNotes: "",
        otherObservations: "",
        detailMovement: {}
      }
    };
  },
  computed: {
    ...mapGetters(['getDetailMovement']),
    isRtleft() {
      return this.$i18n.locale === "ar";
    }
  },
  methods: {
    async fetchRecords() {
      try {

        const detailMovementId = this.detailMovement.id
        const response = await LivestockRecordService.getLivestockRecordByDetailMovementId(detailMovementId);
        this.records = response;
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    },
    async saveRecord() {
      console.log('saveRecord -1-')
      try {
        console.log('saveRecord -2-')
        if (this.formData.id) {
          console.log('saveRecord -2.1-')
          await LivestockRecordService.updateLivestockRecord(this.formData.id, this.formData);
          Message("success", this.$t("message.update_success"));
        } else {
          console.log('saveRecord -2.2-')
          this.formData.detailMovement = { id: this.getDetailMovement.id }
          console.log('this.formData ' + JSON.stringify(this.formData))
          await LivestockRecordService.createLivestockRecord(this.formData);
          Message("success", this.$t("message.add_success"));
        }
        this.resetForm();
        this.fetchRecords();
      } catch (error) {
        Message("danger", this.$t("message.operation_failed"));
      }
    },
    async deleteRecord(id) {
      try {
        console.log('deleteRecord ' + id)
        await LivestockRecordService.deleteLivestockRecord(id);
        this.fetchRecords();
        Message("success", this.$t("message.delete_success"));
      } catch (error) {
        Message("danger", this.$t("message.delete_failed"));
      }
    },
    editRecord(record) {
      this.formData = { ...record };
    },
    resetForm() {
      this.formData = {
        id: null,
        recordDate: "",
        healthStatus: "",
        treatment: "",
        vaccination: "",
        feedingNotes: "",
        otherObservations: ""
      };
    },
    formatPeriod(value, type) {
      if (type === "D") return `${value} ${value == 1 ? "Day" : "Days"}`;
      if (type === "M") return `${value} ${value == 1 ? "Month" : "Months"}`;
      if (type === "Y") return `${value} ${value == 1 ? "Year" : "Years"}`;
      return value;
    }
  },
  mounted() {
    this.detailMovement = this.getDetailMovement
    this.fetchRecords();
  }
};
</script>

<style scoped>
.container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 10px;
}

h2 {
  background-color: #47c399;
  border-radius: 10px 10px 0 0;
  color: azure;
  padding: 3px;
  text-align: justify;
  padding-left: 15px;
}

/* Table Styles */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.custom-table thead tr th {
  background-color: #f2f2f2;
  padding: 6px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 2px;
  text-align: center;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

form button {
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="submit"]:hover {
  background-color: #218838;
}

/* Buttons */
/*
.btn-sm {
  font-size: 12px;
  padding: 5px 10px;
}

.btn-outline-primary,
.btn-outline-danger {
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #fff;
}
*?
/* Responsive Table */
@media (max-width: 768px) {

  .custom-table th,
  .custom-table td {
    font-size: 12px;
    padding: 8px;
  }
}
</style>